export default "__VITE_ASSET__15a4_1NA__"